/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth, useNotification } from '@/containers'
import { useLightbox } from '@/hooks/useLightBox'
import { IconCheckBlue, Star } from '@/styles/Icon'
import type { ProductReview } from '@/types'
import { getAllProductReview } from '@/utils/endpoint'
import { Tab } from '@headlessui/react'
import dayjs from 'dayjs'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useState } from 'react'
import ImageOptimize from '../ImageOptimize'
import ModalCreateReview from '../Popup/ModalCreateReview'
const StarRatings = dynamic(() => import('react-star-ratings'), {
  ssr: false,
})
const ModalListReview = dynamic(() => import('../Popup/ModalListReview'), {
  ssr: false,
})
interface ReviewAndRateType {
  title: string
  productId: string
  reviewSummary: []
  average?: number
}
interface reviewGalleryType {
  value: string
  _id: string
  index: number
}
export const ReviewAndRate = ({
  title,
  productId,
  reviewSummary,
  average,
}: ReviewAndRateType) => {
  const [listReview, setListReview] = useState<ProductReview[] | undefined>()
  const [totalReview, setTotalReview] = useState(0)
  const router = useRouter()
  const [showModalCreateReview, setShowModalCreateReview] = useState(false)
  const [showModalListReview, setShowModalListReview] = useState(false)
  const [reviewGalleryData, setReviewGalleryData] = useState<
    reviewGalleryType[] | string[]
  >([])
  const { token } = useAuth()
  const [filterItemtReview, setFilterItemReview] = useState<
    ProductReview[] | undefined
  >()
  // const [isReadMore, setIsReadMore] = useState(false)
  const [indexGallery, setIndexGallery] = useState(-1)
  const sum = reviewSummary?.reduce((acc, curr) => acc + curr, 0)
  const { openLightBox, renderLightBox } = useLightbox()
  const { systemConfig } = useNotification()
  const filterAttr = [
    { name: 'Mới nhất', type: 0, action: 'sort' },
    { name: 'Có hình ảnh', type: 0, action: 'hasImage' },
    { name: '5', type: 5, action: 'point' },
    { name: '4', type: 4, action: 'point' },
    { name: '3', type: 3, action: 'point' },
    { name: '2', type: 2, action: 'point' },
    { name: '1', type: 1, action: 'point' },
  ]
  const breakpoints = [4320, 2160, 1080, 640, 384, 256, 128]

  const newArrayPoint = reviewSummary.map((value, index) => {
    return {
      point: index + 1,
      value: value,
    }
  })
  useEffect(() => {
    getAllProductReview(`productId=${productId}`).then(async result => {
      if (result && !(result instanceof Error)) {
        setListReview(result.data)
        setFilterItemReview(result.data)
        setTotalReview(result.total)
        return
      }
      setListReview([])
    })
  }, [productId])

  function changeDataReview(e: {
    name?: string
    type: number
    action: string
  }) {
    switch (e?.action) {
      case 'sort':
        getAllProductReview(
          `productId=${productId}&sortBy=createdAt&sortType=desc`
        ).then(async result => {
          if (result && !(result instanceof Error)) {
            setFilterItemReview(result.data)
            return
          }
          setFilterItemReview([])
        })
        break
      case 'hasImage':
        getAllProductReview(`productId=${productId}&hasImage=true`).then(
          async result => {
            if (result && !(result instanceof Error)) {
              setFilterItemReview(result.data)
              return
            }
            setFilterItemReview([])
          }
        )
        break
      case 'point':
        getAllProductReview(`productId=${productId}&point=${e?.type}`).then(
          async result => {
            if (result && !(result instanceof Error)) {
              setFilterItemReview(result.data)
              return
            }
            setFilterItemReview([])
          }
        )
        break
      default:
        getAllProductReview(
          `productId=${productId}&sortBy=createdAt&sortType=desc`
        ).then(async result => {
          if (result && !(result instanceof Error)) {
            setFilterItemReview(result.data)
            return
          }
          setFilterItemReview([])
        })
        break
    }
  }
  const extractedDataImage = listReview
    ?.map((item, index) => {
      const images = item.images.map(value => ({
        value,
        index,
        _id: item._id,
      }))
      return images
    })
    .flat()
  const openReviewGallery = async (
    data: reviewGalleryType[] | string[],
    index: number
  ) => {
    await setReviewGalleryData(data)
    await setIndexGallery(index)
    openLightBox(0)
  }
  return (
    <>
      <div className='review mt-10'>
        <h3
          className='reviewAndRate mb-4 text-lg font-bold leading-5 text-zinc-800'
          id='reviewAndRate'
        >
          <span>Đánh giá </span>
          <span>{title}</span>
        </h3>
        <button
          className='addReview mb-4 flex h-[48px] w-full items-center justify-between rounded border-l-4 border-primary-base bg-white-500 px-4'
          onClick={() => {
            if (token) {
              return setShowModalCreateReview(true)
            }
            return router.push(`/login?&redirect=${router.asPath}`)
          }}
        >
          <span className='text-center text-base text-dark-900'>
            Chia sẻ đánh giá của bạn
          </span>
          <svg
            width={22}
            height={22}
            viewBox='0 0 22 22'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_3760_1038)'>
              <path
                d='M20.1417 9.21623C20.1417 8.37382 20.0404 7.5552 19.8513 6.77092C19.311 5.64474 18.5617 4.63719 17.6544 3.79821C15.9901 2.80403 14.0298 2.2622 11.9483 2.33809C6.20537 2.54739 1.71961 7.37281 1.92891 13.1157C1.95953 13.9559 2.0902 14.7686 2.307 15.5441C2.77548 16.4368 3.37707 17.249 4.08591 17.9538C5.71304 19.0084 7.65278 19.6216 9.73627 19.6216C15.483 19.6216 20.1417 14.9629 20.1417 9.21623ZM14.7657 7.35809C15.4225 7.35809 15.9549 7.89056 15.9549 8.5473C15.9549 9.20404 15.4225 9.7365 14.7657 9.7365C14.109 9.7365 13.5765 9.20404 13.5765 8.5473C13.5765 7.89056 14.109 7.35809 14.7657 7.35809ZM7.40751 7.35809C8.06424 7.35809 8.59671 7.89056 8.59671 8.5473C8.59671 9.20404 8.06424 9.7365 7.40751 9.7365C6.75077 9.7365 6.2183 9.20404 6.2183 8.5473C6.2183 7.89056 6.75077 7.35809 7.40751 7.35809ZM5.25289 13.9644L6.25167 13.319C7.16022 14.7248 8.69029 15.6781 10.3449 15.8689C12.4682 16.114 14.5887 15.1128 15.7478 13.319L16.7467 13.9644C15.4844 15.9179 13.2795 17.0945 10.9788 17.0945C10.7227 17.0945 10.4659 17.08 10.2086 17.0503C8.20479 16.8192 6.35216 15.6656 5.25289 13.9644Z'
                fill='white'
              />
              <path
                d='M19.8513 6.771C20.0404 7.55535 20.1417 8.3739 20.1417 9.2163C20.1417 14.963 15.483 19.6217 9.7363 19.6217C7.65281 19.6217 5.71299 19.0084 4.08594 17.9538C5.86083 19.7186 8.30516 20.8109 10.9998 20.8109C16.4095 20.8109 20.8106 16.4098 20.8106 11.0001C20.8106 9.48669 20.4659 8.05229 19.8513 6.771Z'
                fill='white'
              />
              <path
                d='M11.9488 2.33806C14.0303 2.26217 15.9907 2.804 17.6548 3.79818C15.9048 2.17982 13.5662 1.18921 11.0002 1.18921C5.59055 1.18921 1.18945 5.59031 1.18945 11C1.18945 12.6388 1.59393 14.1848 2.30745 15.5441C2.09065 14.7686 1.95998 13.9558 1.92936 13.1157C1.72006 7.37278 6.20582 2.54736 11.9488 2.33806Z'
                fill='white'
              />
              <path
                d='M11 0C4.93461 0 0 4.93461 0 11C0 17.0654 4.93461 22 11 22C17.0654 22 22 17.0654 22 11C22 4.93461 17.0655 0 11 0ZM11 20.8108C8.30526 20.8108 5.86092 19.7185 4.08611 17.9537C3.37734 17.249 2.77568 16.4368 2.30721 15.5441C1.59368 14.1848 1.18921 12.6388 1.18921 11C1.18921 5.59031 5.59031 1.18921 11 1.18921C13.5659 1.18921 15.9045 2.17981 17.6546 3.79817C18.5619 4.63716 19.3112 5.64471 19.8515 6.77089C20.4661 8.05218 20.8108 9.48659 20.8108 11C20.8108 16.4097 16.4097 20.8108 11 20.8108Z'
                fill='#A8A8A8'
              />
              <path
                d='M7.40796 9.73656C8.06474 9.73656 8.59716 9.20414 8.59716 8.54736C8.59716 7.89058 8.06474 7.35815 7.40796 7.35815C6.75118 7.35815 6.21875 7.89058 6.21875 8.54736C6.21875 9.20414 6.75118 9.73656 7.40796 9.73656Z'
                fill='#A8A8A8'
              />
              <path
                d='M14.7654 9.73656C15.4222 9.73656 15.9546 9.20414 15.9546 8.54736C15.9546 7.89058 15.4222 7.35815 14.7654 7.35815C14.1086 7.35815 13.5762 7.89058 13.5762 8.54736C13.5762 9.20414 14.1086 9.73656 14.7654 9.73656Z'
                fill='#A8A8A8'
              />
              <path
                d='M10.9798 17.0944C13.2804 17.0944 15.4853 15.9178 16.7477 13.9643L15.7489 13.3188C14.5896 15.1127 12.4692 16.1138 10.3459 15.8688C8.6913 15.678 7.16117 14.7247 6.25269 13.3188L5.25391 13.9643C6.35318 15.6655 8.20581 16.8191 10.2096 17.0502C10.4669 17.0799 10.7237 17.0944 10.9798 17.0944Z'
                fill='#A8A8A8'
              />
            </g>
            <defs>
              <clipPath id='clip0_3760_1038'>
                <rect width={22} height={22} fill='white' />
              </clipPath>
            </defs>
          </svg>
        </button>
        <div className='overView flex items-center gap-3 rounded-lg py-3 shadow-200'>
          <div className='star_average relative max-w-[35%] flex-[35%]'>
            <div className='flex flex-col flex-wrap items-center justify-center'>
              <div className='text-black mb-1.5 flex gap-1 text-center text-4xl font-bold'>
                <span className='current'>{average ? average : '5'}</span>
                <span className='seperate'>/</span>
                <span className='limit'>5</span>
              </div>
              <StarRatings
                starRatedColor='#FFCD4B'
                numberOfStars={5}
                rating={average ? average : 5}
                starDimension='24px'
                starSpacing='1px'
                svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
                svgIconViewBox='0 0 40 40'
              />
              <div className='mt-1'>
                <span className='text-base font-extrabold text-neutral-700'>
                  {sum ? sum : 0}
                </span>
                <span className='text-base font-normal text-neutral-700'>
                  {' '}
                  đánh giá
                </span>
              </div>
            </div>
            <div className='absolute right-0 top-[50%] h-[100%] w-px translate-y-[-50%] rounded-[10px] bg-dark-200'></div>
          </div>
          {reviewGalleryData &&
            renderLightBox({
              slides: reviewGalleryData?.map((e: any) => {
                const width = 600 * 4
                const height = 600 * 4
                return {
                  src: e?.value || e,
                  width,
                  height,
                  srcSet: breakpoints.map(breakpoint => {
                    const breakpointHeight = Math.round(
                      (height / width) * breakpoint
                    )
                    return {
                      src: e?.value || e,
                      width: breakpoint,
                      height: breakpointHeight,
                    }
                  }),
                }
              }),
              index: indexGallery,
            })}
          <div className='star_lines max-w-[65%] flex-[65%]'>
            {newArrayPoint &&
              newArrayPoint.reverse().map((key, index) => (
                <div
                  className='star_line flex items-center gap-2 pr-3'
                  key={index}
                >
                  <div className='star_type flex w-5 items-center gap-[2px] text-sm text-neutral-600'>
                    <span className='w-2.5 text-center'>{key.point}</span>
                    <Star />
                  </div>
                  <div className='prog flex-auto relative h-1.5 w-full rounded-[10px] bg-zinc-300'>
                    <div
                      className='prog_bar absolute h-1.5 rounded-[10px] bg-amber-300'
                      style={{
                        width:
                          sum === 0 ? '100%' : (key.value / sum) * 100 + '%',
                      }}
                    ></div>
                  </div>
                  <div className='star_sum_eva w-8'>
                    <span className='text-sm font-normal text-primary-base'>
                      {key.value === 0
                        ? '0%'
                        : Math.round((key.value / sum) * 100) + '%'}
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className='listReviewImage mt-4'>
          <div className='mb-3 w-full'>
            <span className='text-base font-semibold text-dark-400'>
              Tất cả hình ảnh{' '}
            </span>
            <span className='text-base font-normal italic text-dark-400'>
              ({extractedDataImage?.length} hình)
            </span>
          </div>

          <ul className='listImageReview flex w-full items-center justify-start gap-x-3'>
            {extractedDataImage?.slice(0, 7)?.map((e, i) => {
              return (
                <li className='max-w-[14.28%] flex-[14.28%]' key={i + e?.index}>
                  <div
                    onClick={() => openReviewGallery(extractedDataImage, i)}
                    key={i}
                    className='relative block cursor-pointer overflow-hidden rounded-sm'
                  >
                    <ImageOptimize
                      src={e?.value || ''}
                      width={120}
                      height={120}
                      className={'aspect-square w-full object-cover'}
                      alt={'/'}
                    />
                    {i == 6 && (
                      <span className='absolute left-0 top-0 flex h-full w-full items-center justify-center bg-dark-900/50 px-3 text-center text-base leading-tight text-white'>
                        Xem tất cả
                      </span>
                    )}
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
        <Tab.Group>
          <Tab.List
            className='filterReview mt-3 flex flex-wrap items-center'
            as='div'
          >
            <div className='mb-2.5 w-full text-base font-semibold text-dark-400'>
              Lọc xem theo:
            </div>
            <div className='filterItems flex-auto flex w-full justify-start gap-1'>
              {filterAttr.map((e, i) => {
                return (
                  <Tab as={Fragment} key={i}>
                    {({ selected }) => (
                      <button
                        onClick={() => changeDataReview(e)}
                        className={`${
                          selected
                            ? 'border-primary-base text-primary-base'
                            : 'border-stone-50'
                        } flex h-8 items-center gap-1 rounded-lg border bg-stone-50 px-2.5 outline-none hover:border-primary-base hover:text-primary-base`}
                      >
                        {selected ? <IconCheckBlue /> : ''}
                        <span
                          className={`flex items-center gap-[3px] whitespace-nowrap text-sm`}
                        >
                          {e?.name}
                          {e?.action == 'point' && <Star />}
                        </span>
                      </button>
                    )}
                  </Tab>
                )
              })}
            </div>
          </Tab.List>

          <Tab.Panels>
            {filterAttr.map((e, i) => {
              return (
                <Tab.Panel key={i}>
                  <div className='comments mt-2'>
                    {filterItemtReview && filterItemtReview.length > 0 ? (
                      filterItemtReview?.slice(0, 5).map((e, i) => {
                        return (
                          <div
                            className='commentBox relative border-b border-dark-200 py-3 last:border-0'
                            key={i}
                          >
                            <h5 className='text-black text-base font-bold'>
                              {e?.user?.name}
                            </h5>
                            {/* <span className='label absolute right-0 top-4 z-10 flex items-center gap-1  text-sm font-normal text-primary-second'>
                              <IconCheckRed /> Đã mua hàng
                            </span> */}
                            <div className='timeRate mb-2 flex items-center gap-2 leading-none'>
                              <StarRatings
                                starRatedColor='#FFCD4B'
                                numberOfStars={5}
                                rating={e?.point}
                                starDimension='12px'
                                starSpacing='1px'
                                name='reviewAndRate'
                                key={'reviewAndRate'}
                                svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
                                svgIconViewBox='0 0 40 40'
                              />
                              <div className='leading-2 mt-[2px] text-sm font-normal italic text-neutral-500'>
                                {dayjs(e?.createdAt).format(
                                  'HH:mm:ss - DD/MM/YYYY'
                                )}
                              </div>
                            </div>
                            <div className='text-black text-base font-normal'>
                              {e?.content}
                            </div>

                            <ul className='text-black mt-1 flex gap-2 text-base font-normal'>
                              {e?.images
                                .slice(0, 5)
                                .map((imageItem, imageIndex) => {
                                  return (
                                    <li
                                      className='aspect-square max-w-[70px] flex-[70px] cursor-pointer overflow-hidden rounded-sm'
                                      key={imageIndex}
                                      onClick={() =>
                                        openReviewGallery(e?.images, imageIndex)
                                      }
                                    >
                                      <ImageOptimize
                                        src={imageItem || ''}
                                        width={70}
                                        height={70}
                                        alt={e?.content}
                                        className='h-full w-full object-cover'
                                      />
                                    </li>
                                  )
                                })}
                            </ul>
                            {e?.staff && e?.answerContent && (
                              <div className='mt-1 rounded-lg bg-blue-100 px-3 py-2.5'>
                                <div className='text-black flex items-center gap-2 text-base font-bold leading-7'>
                                  <span>
                                    {systemConfig?.authorDefault ||
                                      'Quản trị viên'}
                                  </span>
                                  <span className='flex h-3 w-3 items-center justify-center overflow-hidden rounded-full bg-primary-base'>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width={11}
                                      height={11}
                                      viewBox='0 0 11 11'
                                      fill='none'
                                    >
                                      <g clipPath='url(#clip0_590_6242)'>
                                        <path
                                          d='M10.5176 2.15709C10.2082 1.84728 9.70582 1.84747 9.39601 2.15709L4.34787 7.20542L2.10419 4.96176C1.79438 4.65195 1.29217 4.65195 0.98236 4.96176C0.672547 5.27158 0.672547 5.77378 0.98236 6.08359L3.78684 8.88807C3.94165 9.04288 4.14464 9.12048 4.34765 9.12048C4.55067 9.12048 4.75386 9.04307 4.90867 8.88807L10.5176 3.2789C10.8275 2.9693 10.8275 2.46689 10.5176 2.15709Z'
                                          fill='white'
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id='clip0_590_6242'>
                                          <rect
                                            width={10}
                                            height={10}
                                            fill='white'
                                            transform='translate(0.75 0.522705)'
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                </div>
                                <div className='text-sm font-normal italic leading-5 text-neutral-500'>
                                  {dayjs(e?.answerUpdatedAt).format(
                                    'HH:mm:ss - DD/MM/YYYY'
                                  )}
                                </div>
                                {e?.answerContent ? (
                                  <div className='text-black text-base font-normal leading-6'>
                                    {e?.answerContent}
                                  </div>
                                ) : (
                                  ''
                                )}
                                <ul className='text-black mt-1 flex gap-2 text-base font-normal'>
                                  {e?.answerImages &&
                                    e?.answerImages
                                      .slice(0, 5)
                                      .map((imageItem, imageIndex) => {
                                        return (
                                          <li
                                            className='aspect-square max-w-[70px] flex-[70px] cursor-pointer overflow-hidden rounded-sm'
                                            key={imageIndex}
                                            onClick={() =>
                                              openReviewGallery(
                                                e?.answerImages,
                                                imageIndex
                                              )
                                            }
                                          >
                                            <ImageOptimize
                                              src={imageItem || ''}
                                              width={70}
                                              height={70}
                                              alt={e?.content}
                                              className='h-full w-full object-cover'
                                            />
                                          </li>
                                        )
                                      })}
                                </ul>
                              </div>
                            )}
                          </div>
                        )
                      })
                    ) : (
                      <p className='mt-6 w-full text-center'>
                        Chưa có đánh giá
                      </p>
                    )}
                  </div>
                </Tab.Panel>
              )
            })}
          </Tab.Panels>
        </Tab.Group>
        <div className='action mt-1 flex justify-center gap-x-3'>
          {totalReview && totalReview > 5 ? (
            <button
              className='addReview flex h-[50px] w-full min-w-[200px] items-center justify-center rounded border border-blue-base'
              onClick={() => setShowModalListReview(true)}
            >
              <span className='text-center text-base font-bold text-blue-base'>
                Xem thêm {totalReview - 5} đánh giá
              </span>
            </button>
          ) : (
            ''
          )}
        </div>
      </div>

      <ModalCreateReview
        showModalCreateReview={showModalCreateReview}
        setShowModalCreateReview={setShowModalCreateReview}
        productName={title}
        productId={productId}
      />
      <ModalListReview
        showModalListReview={showModalListReview}
        setShowModalListReview={setShowModalListReview}
        productName={title}
        productId={productId}
        average={average}
        reviewSummary={reviewSummary}
      />
    </>
  )
}

export default ReviewAndRate
